<div role="tablist" class="tab-header flex flex--align-end border-none no-bg">
  <ng-content />
</div>
